<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="ma-0 pa-0">
          <v-row no-gutters class="ma-0" justify="end">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("property.unitType.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="5">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                placeholder="Name"
                class="mx-2 custom-label-color"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="showRightSideDrawer('UNIT_TYPE')">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("property.unitType.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          id="unitTypeTable"
          :headers="headers"
          :items="unitTypeLists"
          :search="search"
          class="mt-3 mb-9 datatable"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalUnitTypes"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  unitTypeLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" @click="editUnitType(item)"
                >mdi-pencil</v-icon
              >
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { deleteUnitType } from "../methods/unitType/delete_unit_type";
export default {
  data() {
    return {
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      unitTypeLists: [],
      totalUnitTypes: 10
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          align: "left",
          value: "nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          align: "left",
          value: "nameAr",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          align: "left",
          sortable: false,
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getUnitTypes.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalUnitTypes,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getUnitTypes.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalUnitTypes,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getUnitTypes() {
      this.loading = true;
      return {
        query: require("@/property/api/queries/unitType/unit_type_query.graphql"),
        variables: {
          input: {
            limit: this.totalUnitTypes,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.unitTypeLists = this.$format.cloneVariable(
            data.getUnitTypes.unitTypes
          );
          this.loading = loading;
          this.totalUnitTypes = data.getUnitTypes.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("deleteItems", data => {
      if (data.module === "unitType") {
        const input = data.item._id;
        deleteUnitType(input).then(data => {
          if (data.data.deleteUnitType) {
            this.$apollo.queries.getUnitTypes.refetch({
              limit:
                this.options.itemsPerPage !== -1
                  ? this.options.itemsPerPage
                  : this.totalUnitTypes,
              skip:
                this.options.page * this.options.itemsPerPage -
                this.options.itemsPerPage
            });
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.deleteSuccess"),
              color: "green"
            });
            this.$store.commit("DELETE_BTN_LOADING", false);
          }
        });
      }
    });
    this.$root.$on("unitTypeTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchUnitType", () => {
      this.$apollo.queries.getUnitTypes.refetch({
        limit:
          this.options.itemsPerPage !== -1
            ? this.options.itemsPerPage
            : this.totalUnitTypes,
        skip:
          this.options.page * this.options.itemsPerPage -
          this.options.itemsPerPage
      });
    });
    this.$root.$on("searchUnitType", data => {
      this.search = data;
    });
    this.$root.$on("exportUnitType", () => {
      this.exportData();
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("PROPERTY_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getUnitTypes
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(response => {
          this.options.itemsPerPage = response.data.getUnitTypes.totalCount;
          this.unitTypeLists = response.data.getUnitTypes.unitTypes;
          setTimeout(() => {
            this.htmlToExcel("unitTypeTable");
          }, 1000);
        });
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", {
        dialog: true,
        item: item,
        module: "unitType"
      });
    },
    editUnitType(item) {
      this.$store.commit("IS_EDIT_UNIT_TYPE", true);
      this.$store.commit("EDIT_UNIT_TYPE", item);
      this.$store.commit("PROPERTY_FORMNAME", "UNIT_TYPE");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("unitTypeTable");
    this.$root.$off("refetchUnitType");
    this.$root.$off("searchUnitType");
    this.$root.$off("exportUnitType");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
